import type { FileTypeMeta } from '@/types/common';

const BINARY_SIZE_MULTIPLIER = 1024;
export const KB = BINARY_SIZE_MULTIPLIER;
export const MB = KB * BINARY_SIZE_MULTIPLIER;
export const GB = MB * BINARY_SIZE_MULTIPLIER;
export const TB = GB * BINARY_SIZE_MULTIPLIER;

export const MAX_SIZE_DOCS_MEGABYTES = 10;
export const MAX_SIZE_IMG_MEGABYTES = 2;
export const MAX_SIZE_IMG_BYTES = MAX_SIZE_IMG_MEGABYTES * MB;
export const MAX_PROJECT_DOCUMENT_SIZE_BYTES = 2 * GB;

export const PDF_TYPE = 'application/pdf';
export const IMG_TYPES = ['image/jpeg', 'image/png', 'image/gif'];

export const DEFAULT_IMAGE = '/promo-header-large.png';

type DocumentMimeTypeMeta = FileTypeMeta & {
    uploadSupported: boolean;
};

export const DocumentMimeTypes: Readonly<Record<string, DocumentMimeTypeMeta>> = Object.freeze({
    'application/pdf': {
        icon: 'br-icon:file-type-pdf',
        label: 'PDF',
        uploadSupported: true
    },
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
        icon: 'br-icon:file-type-docx',
        label: 'DOCX',
        uploadSupported: true
    },
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
        icon: 'br-icon:file-type-xls',
        label: 'XLSX',
        uploadSupported: true
    },
    'text/plain': {
        icon: 'br-icon:file-type-txt',
        label: 'TXT',
        uploadSupported: true
    },
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': {
        icon: 'br-icon:file-type-ppt',
        label: 'PPTX',
        uploadSupported: true
    },
    'application/zip': {
        icon: 'br-icon:file-type-zip',
        label: 'ZIP',
        uploadSupported: false
    },
    'application/x-zip-compressed': {
        icon: 'br-icon:file-type-zip',
        label: 'ZIP',
        uploadSupported: false
    },
    'text/csv': {
        icon: 'br-icon:file-type-csv',
        label: 'CSV',
        uploadSupported: false
    },
    'application/csv': {
        icon: 'br-icon:file-type-csv',
        label: 'CSV',
        uploadSupported: false
    },
    'text/comma-separated-values': {
        icon: 'br-icon:file-type-csv',
        label: 'CSV',
        uploadSupported: false
    },
    'application/json': {
        icon: 'br-icon:file-type-json',
        label: 'JSON',
        uploadSupported: false
    },
    'text/json': {
        icon: 'br-icon:file-type-json',
        label: 'JSON',
        uploadSupported: false
    }
});

export const AcceptedDocumentMimeTypes = Object.freeze(
    Object.entries(DocumentMimeTypes)
        .filter(([, meta]) => meta.uploadSupported)
        .map(([mimeType]) => mimeType)
);
